import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  UpdateTenderDetailsMutation,
  UpdateTenderDetailsMutationVariables,
  UpdateTenderDetailsDocument,
} from "@/graphql/__generated__/graphql";

export default function useUpdateTenderDetailsMutationHook(): {
  updateTenderDetailsMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [updateTenderDetailsMutation, { loading, error }] = useMutation<UpdateTenderDetailsMutation, UpdateTenderDetailsMutationVariables>(
    UpdateTenderDetailsDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "tender-details-updated-success",
          data: {
            title: t("toasts.tenderdetailsupdated"),
            type: "success",
          },
        });
      },
    });

  return {
    updateTenderDetailsMutation,
    loading,
    error,
  };
}
